export const getRankStyle = (rank: number) => {
  switch (rank) {
    case 0:
      return {
        color: '#A68111',
        background: '#F9F7E6',
      };
    case 1:
      return {
        color: '#5E5E5E',
        background: '#F0F0F0',
      };
    case 2:
      return {
        color: '#826444',
        background: '#F1EDE6',
      };
    default:
      return {
        color: '#A68111',
        background: '#F9F7E6',
      };
  }
};
